import {
  type BroadbandPlanMember,
  ESwitchType,
  SwitchDetailsModal,
  type SwitchDetailsModalData,
} from '@giffgaff/broadband-common'

import { useGetSwitchById } from '@/hooks/apiHooks'

export type SwitchDetailsModalContainerProps = {
  isOpen: boolean
  handleClose: () => void
  plan?: BroadbandPlanMember
}

const SwitchDetailsModalContainer = ({ isOpen, handleClose, plan }: SwitchDetailsModalContainerProps) => {
  const switchId: string | undefined = plan?.switchId

  const { data: switchData } = useGetSwitchById({ switchId }, { enabled: !!(isOpen && switchId) })

  const switchDetails: SwitchDetailsModalData | undefined = switchData
    ? {
        switchReferenceNumber: switchData.switchOrderReference,
        providerName:
          switchData.switchType === ESwitchType.GAINING
            ? switchData.losingProviderName
            : switchData.gainingProviderName,
        switchCompletionDate: switchData.plannedSwitchDate,
        homeAddress: [switchData.address, switchData.postTown, switchData.postcode].filter(item => !!item).join(' '),
        lastName: switchData.lastName,
        providerAccountNumber: switchData.losingProviderAccountNumber,
        switchType: switchData.switchType,
      }
    : undefined

  if (!switchDetails) {
    return null
  }

  return <SwitchDetailsModal data={switchDetails} handleClose={handleClose} isOpen={isOpen} />
}

export default SwitchDetailsModalContainer
